// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var rtlChars = /[\u0600-\u06FF]|[\u0750-\u077F]|[\u0590-\u05FF]|[\uFE70-\uFEFF]/gm;
export default rtlChars;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twitter-text/dist/esm/regexp/rtlChars.js
// module id = 402
// module chunks = 110